import _ from 'lodash'
import { FilterOptionTypes } from '@/store/types'

/**
 * Utility functions to handle generic filters used in the system using the [All, Include, Exclude] method of filtering data
 * 
 */
export default class FilterUtils {


  /**
   * Check if an item or array of items passes a test against a filter
   */
  static itemPassesFilter(filterData, items) {
    if(!_.isArray(items))
      items = [items]

    if(!filterData)
      return true

    // If all, everything passes
    if(filterData.type == FilterOptionTypes.all)
      return true

    for(var itemId of items) {

      if(filterData.type == FilterOptionTypes.include) {
        // At least one item MUST be in the include list
        if(_.isArray(filterData.valueList)) {
          if(filterData.valueList.indexOf(itemId) != -1) {
            return true
          }
        } else {
          if(itemId == filterData.valueList)
            return true
        }
      }

      else if(filterData.type == FilterOptionTypes.exclude) {
        // No items can be in the exclude list
        if(_.isArray(filterData.valueList)) {
          if(filterData.valueList.indexOf(itemId) != -1)
            return false
        } else {
          if(itemId == filterData.valueList)
            return false
        }
      }
    }

    // If nothing found exclude list, we can pass
    if(filterData.type == FilterOptionTypes.exclude)
      return true

    return false
  }


}